import React from 'react' ;

import Button from '../../Buttons/Button' ;


import './FormulaireDemandeGamme.scss' ;


function FormulaireDemandeGamme({gammes, setGammes}){


    const ajoutgamme = ()=>{
        setGammes(prevGammes=> [...prevGammes,{nom:"", commissions:""}] ) ;
    } ;

    const changeGamme = (e)=>{
        const {id,value} = e.target ;
        const newgammes = [...gammes] ;
        newgammes[id] = {"nom":value, "commissions":newgammes[id]?.commissions} ;
        setGammes(newgammes) ;
    } ;

    const changeGammeCommission = (e)=>{        
        const {id,value} = e.target ;
        const newgammes = [...gammes] ;
        newgammes[id] = {"nom":newgammes[id]?.nom, "commissions":value} ;
        setGammes(newgammes) ;
    }


   return (<div><br/>
            <div className='titreformulairedemandegamme'>Liste des Gammes et commissions.</div><br/>
                {gammes?.length >0 &&  <div>
                    <div className='titreformulairedemandegamme first' >Nom de la Gamme</div>
                    <div className='titreformulairedemandegamme'>Commissions separées par une virgule </div>
                </div>}
                 {gammes?.map((g,index)=>(<div key={index}>
                                                <input className='inputformulairedemandegamme'  id={index} value={g.nom}  onChange={changeGamme}  />
                                                <input className='inputformulairedemandegamme'  id={index} value={g.commissions}  onChange={changeGammeCommission}  />
                                            </div>))}
       
                   <Button texte='Ajouter une gamme' 
                            color='bouton_color_vert'
                            size='bouton_size_normal' 
                            onclick={ajoutgamme} />
                     <br/> <br/>
            

            </div>)
}

export default FormulaireDemandeGamme